import React from "react";
import HorizontalBtnIcon from "@components/Svg/HorizontalBtnIcon";
import VerticalBtnIcon from "@components/Svg/VerticalBtnIcon";
import SelectInput from "@components/UI/Inputs/SelectInput/SelectInput";
import { Sort, TimeSlots } from "../catalog-utils";
import { SortingProps } from "./types";
import classes from "./catalog-list.module.scss";

const Sorting: React.FC<SortingProps> = ({
    selectWidth,
    allParamsSort,
    timeSort,
    defaultTimeSort,
    isVertical,
    onParamsSortChanged,
    onTimeSortChanged,
    onFilterChanged,
    setIsVertical
}) => {
    return (
        <>
            <SelectInput
                width={selectWidth}
                isClearable={allParamsSort === Sort.Popular ? false : true}
                instanceId={"sort-react-select1231s"}
                className={classes.Select}
                value={{ value: allParamsSort, label: allParamsSort }}
                onChange={(val) => {
                    if (!val?.value) {
                        onParamsSortChanged(Sort.Popular);
                    } else {
                        onParamsSortChanged(val.value);
                    }
                }}
                isSearchable={false}
                ariaLabel={"Сортировка по параметрам"}
                options={[
                    { value: Sort.Popular, label: Sort.Popular },
                    { value: Sort.Cheap, label: Sort.Cheap },
                    { value: Sort.Expensive, label: Sort.Expensive },
                    { value: Sort.YearNewer, label: Sort.YearNewer },
                    { value: Sort.YearOlder, label: Sort.YearOlder },
                    { value: Sort.MileageLess, label: Sort.MileageLess },
                    { value: Sort.MileageMore, label: Sort.MileageMore },
                    { value: Sort.ByName, label: Sort.ByName }
                ]}
            />

            <SelectInput
                isClearable={timeSort !== defaultTimeSort}
                className={classes.Select2}
                width={selectWidth}
                instanceId={"sort2-react-selectasdfsdf3"}
                value={
                    timeSort
                        ? {
                              value: timeSort,
                              label: timeSort
                          }
                        : { value: defaultTimeSort, label: defaultTimeSort }
                }
                onChange={(val) => {
                    if (val?.value) {
                        onTimeSortChanged(val?.value);
                    } else {
                        onTimeSortChanged(defaultTimeSort);
                    }

                    if (onFilterChanged) {
                        onFilterChanged();
                    }
                }}
                ariaLabel={"Сортировка по времени"}
                options={TimeSlots}
            />

            <div className={classes.Divider}></div>

            <a
                className={classes.HorizontalBtn}
                href="#"
                aria-label="Горизонтальный вид каталога"
                onClick={(e) => {
                    e.preventDefault();
                    setIsVertical(false);
                }}
            >
                <HorizontalBtnIcon isActive={!isVertical} />
            </a>
            <a
                className={classes.VerticalBtn}
                href="#"
                aria-label="Вертикальный вид каталога"
                onClick={(e) => {
                    e.preventDefault();
                    setIsVertical(true);
                }}
            >
                <VerticalBtnIcon isActive={isVertical} />
            </a>
        </>
    );
};

export default Sorting;